import {CallNotification} from "../actionTypes";

export const changeCallNotification = (notificationId) => ({ type: CallNotification.CHANGE_CALL_NOTIFICATION, payload: notificationId });
export const loadCallNotificationInfoRequestSuccess = (responseData) => ({ type: CallNotification.LOAD_CALL_NOTIFICATION_INFO_REQUEST_SUCCESS, payload: responseData });